// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* signin start */

.signin input {
  font-size: 18px;
}

.signin h1 {
  color: #ffff;
  font-style: normal;
  font-style: normal;
  font-weight: 600;
  font-size: 45px;
  line-height: 54px;
  align-items: center;
  text-align: center;
  font-family: "museo_sans700";
  color: #000000;
}

.box-signin {
  background: #ffff;
  width: 500px;
  height: 400px;
  margin-top: 2%;
  border-radius: 6px;
  border: 1px solid #e5e5ea !important;
}

.box-signin-partner {
  background: #ffff;
  /* box-shadow: 0 0 10px 6.5px #c33ca6; */
  border-radius: 10px;
  margin-top: 2%;
  border-radius: 6px;
  border: 1px solid #e5e5ea !important;
}

.model-x-button button {
  position: absolute;
  right: 0;
  font-size: 18px;
  z-index: 9;
}

.model-x-forgot .modal-dialog {
  margin-top: 8%;
}

.model-x-forgot input {
  width: 100%;
}

.signin button.button {
  background: #111727;
  color: #ffff !important;
  font-family: "museo_sans700";
  font-style: normal;
  font-size: 30px;
  font-weight: 600;
}

.signin button.button :hover {
  background: #111727;
  color: #ffff !important;
  font-family: "museo_sans700";
  font-style: normal;
  font-size: 30px;
  font-weight: 600;
}

.eyepasswordsignin {
  position: absolute;
  padding: 35px;
  right: 33%;
  color: #d0cfcf;
  font-size: 18px !important;
}

.eyepasswordsignin :hover {
  right: 33%;
  color: #fab818;
  font-size: 18px !important;
}

.box-signin a {
  text-decoration: none;
}

.forgot {
  text-align: end;
  font-family: "museo_sans300";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 22px;
  text-decoration: none;
  color: #676666;
  cursor: pointer;
}

.signin i.rounded {
  font-size: 30px;
  width: 40px;
  margin: 5px;
  color: #929191;
  height: 43px;
}

.signin i.rounded :hover {
  font-size: 30px;
  width: 40px;
  margin: 5px;
  color: #fab818;
  height: 43px;
}

.rounded {
  border: 1px solid;
  /* border-radius: 50% !important; */
  padding: 1%;
}

.accountsign {
  color: #676666;
}

.accountsign span {
  color: #fab818;
  text-decoration: underline;
}

h6.social-login {
  font-family: "museo_sans300";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 22px;
  color: #676666;
}

.siginerror {
  color: red;
  /* margin-left: 13%; */
  margin-top: 1%;
  display: flex;
  font-family: "museo_sans300";
}

.siginerrorlogin {
  color: red;
  margin-left: 11%;
  margin-top: 1%;
  display: flex;
  font-family: "museo_sans300";
}

.loginfailederror_mismatch {
  color: red;
  margin-top: 1%;
  font-size: 15px;
}

.Remember {
  font-size: 1vw;
  margin-left: 13% !important;
  color: #000000;
}

.Remember label {
  margin-left: 1%;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  color: #000000 !important;
}

.signin-logo-images {
  height: 40px;
}

.forgot {
  font-size: 15px;
  font-family: 'Poppins';
  line-height: 27px;
  font-weight: 500;
}

.custom-loading {
  width: 20px;
  height: 20px;
  border: 2px solid #fff;
  border-top-color: transparent;
  border-radius: 50%;
  animation: loading 1s linear infinite;
}

@keyframes loading {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }

}

/* signin end */

/* Mobile view  */

/* Custom, iPhone Retina */
@media only screen and (min-width: 320px) {
  .eyepasswordsignin {
    position: absolute;
    padding: 35px;
    right: 4%;
    font-size: 18px !important;
  }
}

/* Extra Small Devices, Phones */
@media only screen and (min-width: 480px) {
  .eyepasswordsignin {
    position: absolute;
    padding: 35px;
    right: 22%;
    font-size: 18px !important;
  }
}

/* Small Devices, Tablets */
@media only screen and (min-width: 768px) {
  .eyepasswordsignin {
    position: absolute;
    padding: 35px;
    right: 18%;
    font-size: 18px !important;
  }
}

/* Medium Devices, Desktops */
@media only screen and (min-width: 992px) {
  .eyepasswordsignin {
    position: absolute;
    padding: 35px;
    right: 32%;
    font-size: 18px !important;
  }
}

/* Large Devices, Wide Screens */
@media only screen and (min-width: 1200px) {
  .eyepasswordsignin {
    position: absolute;
    padding: 35px;
    right: 36%;
    font-size: 18px !important;
  }
}

@media only screen and (min-width: 1024px) {
  .eyepasswordsignin {
    position: absolute;
    padding: 35px;
    right: 31%;
    font-size: 18px !important;
  }
}

@media screen and (min-width: 1400px) {
  .eyepasswordsignin {
    position: absolute;
    padding: 35px;
    right: 33%;
    font-size: 18px !important;
  }
}

@media screen and (min-width: 1600px) {
  .eyepasswordsignin {
    position: absolute;
    padding: 35px;
    right: 38%;
    font-size: 18px !important;
  }
}

@media screen and (min-width: 1900px) {
  .eyepasswordsignin {
    position: absolute;
    padding: 35px;
    right: 41%;
    font-size: 18px !important;
  }
}

@media screen and (min-width: 2400px) {
  .eyepasswordsignin {
    position: absolute;
    padding: 35px;
    right: 41%;
    font-size: 18px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Signin/signin.css"],"names":[],"mappings":"AAAA,iBAAiB;;AAEjB;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,wCAAwC;EACxC,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,WAAW;EACX,cAAc;EACd,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;EACX,WAAW;EACX,cAAc;EACd,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mCAAmC;EACnC,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,6BAA6B;EAC7B,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;;AAEF;;AAEA,eAAe;;AAEf,iBAAiB;;AAEjB,0BAA0B;AAC1B;EACE;IACE,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,0BAA0B;EAC5B;AACF;;AAEA,gCAAgC;AAChC;EACE;IACE,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV,0BAA0B;EAC5B;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV,0BAA0B;EAC5B;AACF;;AAEA,6BAA6B;AAC7B;EACE;IACE,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV,0BAA0B;EAC5B;AACF;;AAEA,gCAAgC;AAChC;EACE;IACE,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV,0BAA0B;EAC5B;AACF","sourcesContent":["/* signin start */\n\n.signin input {\n  font-size: 18px;\n}\n\n.signin h1 {\n  color: #ffff;\n  font-style: normal;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 45px;\n  line-height: 54px;\n  align-items: center;\n  text-align: center;\n  font-family: \"museo_sans700\";\n  color: #000000;\n}\n\n.box-signin {\n  background: #ffff;\n  width: 500px;\n  height: 400px;\n  margin-top: 2%;\n  border-radius: 6px;\n  border: 1px solid #e5e5ea !important;\n}\n\n.box-signin-partner {\n  background: #ffff;\n  /* box-shadow: 0 0 10px 6.5px #c33ca6; */\n  border-radius: 10px;\n  margin-top: 2%;\n  border-radius: 6px;\n  border: 1px solid #e5e5ea !important;\n}\n\n.model-x-button button {\n  position: absolute;\n  right: 0;\n  font-size: 18px;\n  z-index: 9;\n}\n\n.model-x-forgot .modal-dialog {\n  margin-top: 8%;\n}\n\n.model-x-forgot input {\n  width: 100%;\n}\n\n.signin button.button {\n  background: #111727;\n  color: #ffff !important;\n  font-family: \"museo_sans700\";\n  font-style: normal;\n  font-size: 30px;\n  font-weight: 600;\n}\n\n.signin button.button :hover {\n  background: #111727;\n  color: #ffff !important;\n  font-family: \"museo_sans700\";\n  font-style: normal;\n  font-size: 30px;\n  font-weight: 600;\n}\n\n.eyepasswordsignin {\n  position: absolute;\n  padding: 35px;\n  right: 33%;\n  color: #d0cfcf;\n  font-size: 18px !important;\n}\n\n.eyepasswordsignin :hover {\n  right: 33%;\n  color: #fab818;\n  font-size: 18px !important;\n}\n\n.box-signin a {\n  text-decoration: none;\n}\n\n.forgot {\n  text-align: end;\n  font-family: \"museo_sans300\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 22px;\n  text-decoration: none;\n  color: #676666;\n  cursor: pointer;\n}\n\n.signin i.rounded {\n  font-size: 30px;\n  width: 40px;\n  margin: 5px;\n  color: #929191;\n  height: 43px;\n}\n\n.signin i.rounded :hover {\n  font-size: 30px;\n  width: 40px;\n  margin: 5px;\n  color: #fab818;\n  height: 43px;\n}\n\n.rounded {\n  border: 1px solid;\n  /* border-radius: 50% !important; */\n  padding: 1%;\n}\n\n.accountsign {\n  color: #676666;\n}\n\n.accountsign span {\n  color: #fab818;\n  text-decoration: underline;\n}\n\nh6.social-login {\n  font-family: \"museo_sans300\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 22px;\n  color: #676666;\n}\n\n.siginerror {\n  color: red;\n  /* margin-left: 13%; */\n  margin-top: 1%;\n  display: flex;\n  font-family: \"museo_sans300\";\n}\n\n.siginerrorlogin {\n  color: red;\n  margin-left: 11%;\n  margin-top: 1%;\n  display: flex;\n  font-family: \"museo_sans300\";\n}\n\n.loginfailederror_mismatch {\n  color: red;\n  margin-top: 1%;\n  font-size: 15px;\n}\n\n.Remember {\n  font-size: 1vw;\n  margin-left: 13% !important;\n  color: #000000;\n}\n\n.Remember label {\n  margin-left: 1%;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 18px;\n  color: #000000 !important;\n}\n\n.signin-logo-images {\n  height: 40px;\n}\n\n.forgot {\n  font-size: 15px;\n  font-family: 'Poppins';\n  line-height: 27px;\n  font-weight: 500;\n}\n\n.custom-loading {\n  width: 20px;\n  height: 20px;\n  border: 2px solid #fff;\n  border-top-color: transparent;\n  border-radius: 50%;\n  animation: loading 1s linear infinite;\n}\n\n@keyframes loading {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n\n}\n\n/* signin end */\n\n/* Mobile view  */\n\n/* Custom, iPhone Retina */\n@media only screen and (min-width: 320px) {\n  .eyepasswordsignin {\n    position: absolute;\n    padding: 35px;\n    right: 4%;\n    font-size: 18px !important;\n  }\n}\n\n/* Extra Small Devices, Phones */\n@media only screen and (min-width: 480px) {\n  .eyepasswordsignin {\n    position: absolute;\n    padding: 35px;\n    right: 22%;\n    font-size: 18px !important;\n  }\n}\n\n/* Small Devices, Tablets */\n@media only screen and (min-width: 768px) {\n  .eyepasswordsignin {\n    position: absolute;\n    padding: 35px;\n    right: 18%;\n    font-size: 18px !important;\n  }\n}\n\n/* Medium Devices, Desktops */\n@media only screen and (min-width: 992px) {\n  .eyepasswordsignin {\n    position: absolute;\n    padding: 35px;\n    right: 32%;\n    font-size: 18px !important;\n  }\n}\n\n/* Large Devices, Wide Screens */\n@media only screen and (min-width: 1200px) {\n  .eyepasswordsignin {\n    position: absolute;\n    padding: 35px;\n    right: 36%;\n    font-size: 18px !important;\n  }\n}\n\n@media only screen and (min-width: 1024px) {\n  .eyepasswordsignin {\n    position: absolute;\n    padding: 35px;\n    right: 31%;\n    font-size: 18px !important;\n  }\n}\n\n@media screen and (min-width: 1400px) {\n  .eyepasswordsignin {\n    position: absolute;\n    padding: 35px;\n    right: 33%;\n    font-size: 18px !important;\n  }\n}\n\n@media screen and (min-width: 1600px) {\n  .eyepasswordsignin {\n    position: absolute;\n    padding: 35px;\n    right: 38%;\n    font-size: 18px !important;\n  }\n}\n\n@media screen and (min-width: 1900px) {\n  .eyepasswordsignin {\n    position: absolute;\n    padding: 35px;\n    right: 41%;\n    font-size: 18px !important;\n  }\n}\n\n@media screen and (min-width: 2400px) {\n  .eyepasswordsignin {\n    position: absolute;\n    padding: 35px;\n    right: 41%;\n    font-size: 18px !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
